module.exports = __webpack_public_path__ + "img/logo1.f7fa3423.png";